import { render, staticRenderFns } from "./MakeQuestionMath.vue?vue&type=template&id=27f5be57&scoped=true&lang=pug&"
import script from "./MakeQuestionMath.vue?vue&type=script&lang=ts&"
export * from "./MakeQuestionMath.vue?vue&type=script&lang=ts&"
import style0 from "./MakeQuestionMath.vue?vue&type=style&index=0&id=27f5be57&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f5be57",
  null
  
)

export default component.exports